(function () {
  function initNcMiniCart() {
    document.querySelectorAll('[data-nc-mini-cart]').forEach(function (drawer) {
      if (drawer.dataset.ncMiniCartReady === 'true') return;

      drawer.dataset.ncMiniCartReady = 'true';

      var checkoutButton = drawer.querySelector('#bt_checkout_mini');
      var miniCartForm = drawer.querySelector('#mini-cart-form');

      if (!checkoutButton || !miniCartForm) return;

      miniCartForm.addEventListener('submit', function () {
        checkoutButton.classList.add('is-loading');
        checkoutButton.setAttribute('aria-busy', 'true');
      });

      window.addEventListener('pageshow', function () {
        checkoutButton.classList.remove('is-loading');
        checkoutButton.removeAttribute('aria-busy');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNcMiniCart);
  } else {
    initNcMiniCart();
  }

  document.addEventListener('shopify:section:load', initNcMiniCart);
})();